export default __webpack_public_path__ + "static/media/dribbble.a8476a2b.svg";